import { createStore } from "zustand/vanilla";
import { EDocumentQueryParams } from "@onair/services/e-document";
import { OrderByEnum } from "@onair/repositories";
type EDocFilterState = {
	q: EDocumentQueryParams["filter"];
	limit: EDocumentQueryParams["limit"];
	offset: EDocumentQueryParams["offset"];
	order: EDocumentQueryParams["order"];
	orderField: EDocumentQueryParams["orderField"];
};

type EDocFilterAction = {
	setSearchText: (search?: string) => void;
};

type CourseSearchStore = EDocFilterState & EDocFilterAction;

const initEDocsQueryParams: EDocFilterState = {
	q: "",
	offset: 1,
	order: OrderByEnum.ASC,
	orderField: "",
	limit: 16,
};
const createEDocumentFilterStore = (initState?: EDocFilterState) =>
	createStore<CourseSearchStore>()((set) => ({
		...initEDocsQueryParams,
		...initState,
		setSearchText: (search) => set((state) => ({ ...state, q: search })),
	}));

export { createEDocumentFilterStore };
export type { CourseSearchStore, EDocFilterAction, EDocFilterState };
